import {createFileRoute} from "@tanstack/react-router"
import {MobileMenuProfile} from "@/components/profile/MobileMenuProfile/MobileMenuProfile.tsx"

export const Route = createFileRoute("/_mainLayout/profile/mobileMenu/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MobileMenuProfile/>
  );
}
